// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__z5IeI","image":"style_image__2Jz4U","imagePlaceholder":"style_imagePlaceholder__255K9","content":"style_content__2mQiJ"};